import { Result, ValidateCouponRequest, ValidateCouponResult } from "@models";
import requests from "./agent";

export const couponService = {
  validate: async (request: ValidateCouponRequest) => {
    const response = await requests.post<Result<ValidateCouponResult>>(
      "/api/Coupon/Validate",
      request
    );
    return response.result;
  },
};
